module.exports = __webpack_public_path__ + "img/callee.be0a1c47.svg";